<template>
    <div id="mail-integration">
        <AppBreadCrumb
            :paths="[{ title: $t('chatbotv2.emailProvider') }]"
            :select="true"
            class="mail-integration-bread-crumb"
        >
        </AppBreadCrumb>
        <span class="main-integrations">
            <div class="title">{{ $t("chatbotv2.emailProvider") }}</div>
            <div class="integrations">
                <span class="fix-align">
                    <span class="img">
                        <img :src="logoUrl" />
                    </span>
                    <span>
                        <div class="integration-name">{{ $t("mail.integrateYourMail") }}</div>
                        <div class="domain-name">{{ emailDomain }}</div>
                    </span>
                </span>
                <span class="fix-align" v-if="domainIsCreated && emailBtnEnabled">
                    <span class="material-icons done"> done </span>
                    <span class="connected-name">{{ $t("settings.connected") }}</span>
                </span>
                <span class="fix-align" v-if="!domainIsCreated && emailBtnEnabled">
                    <button class="connect-button" @click="createDomain">
                        <span class="connect-name">{{ $t("mail.connect") }}</span>
                    </button>
                </span>
                <span class="fix-align" v-if="!emailBtnEnabled">
                    <button class="connect-button disabled">
                        <span class="connect-name disabled">LOADING..</span>
                    </button>
                </span>
            </div>
        </span>
        <span class="user-integrations">
            <div class="user-email-name">{{ $t("akinon.userEmail") }}</div>
            <div class="channels">
                <div class="story channel-add" @click="showModel()">
                    <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                    <span class="text-large font-weight-bolder mt-2" style="font-size: 15px">
                        {{ $t("message.addNewAddress") }}
                    </span>
                </div>
                <div
                    class="channel-item"
                    v-for="userMailAddress of userEmailAddresses"
                    @click="mailDetail(false, userMailAddress._id)"
                >
                    <div class="icon-container">
                        <MailIcon style="width: 40px; height: 40px" />
                    </div>
                    <div class="name-container">
                        <a-tooltip :title="getDepartmentName(userMailAddress._id)">
                            <span class="user-name">{{
                                user.name.length > 12 ? user.name.substring(0, 12) + "..." : user.name
                            }}</span>
                        </a-tooltip>
                        <a-tooltip :title="userMailAddress.mail">
                            <span class="mail-name">{{
                                userMailAddress.mail.length > 20
                                    ? userMailAddress.mail.substring(0, 20) + "..."
                                    : userMailAddress.mail
                            }}</span>
                        </a-tooltip>
                    </div>
                </div>
            </div>
        </span>
        <div class="department-integrations">
            <div class="department-title-name">{{ $t("mail.departmentMail") }}</div>
            <div class="channels">
                <div
                    class="story"
                    :class="departmentMailAddress.length !== subjects.total ? 'channel-add' : 'channel-add-disable'"
                    @click="showModel(true)"
                >
                    <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                    <span class="text-large font-weight-bolder mt-2" style="font-size: 15px">
                        {{ $t("message.addNewAddress") }}
                    </span>
                </div>
                <div
                    class="channel-item"
                    v-for="department of departmentMailAddress"
                    @click="mailDetail(true, department)"
                >
                    <div class="icon-container">
                        <MailIcon style="width: 40px; height: 40px" />
                    </div>
                    <div class="name-container">
                        <a-tooltip :title="getDepartmentName(department)">
                            <span class="name">{{
                                getDepartmentName(department).length > 12
                                    ? getDepartmentName(department).substring(0, 12) + "..."
                                    : getDepartmentName(department)
                            }}</span>
                        </a-tooltip>
                        <a-tooltip :title="department.mail">
                            <span class="mail-name">{{
                                department.mail.length > 20 ? department.mail.substring(0, 20) + "..." : department.mail
                            }}</span>
                        </a-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <Modal2
            :title="$t('mail.createMailAddress')"
            class-name="new-waba"
            :showFooter="false"
            @cancel="handleCancel()"
            v-if="showCreateUserMail || showCreateDepartmentMail"
        >
            <!-- seçilir kutudan departman seçtir -->
            <b-form-group
                :label="$t('message.selectTopic')"
                label-for="type-input"
                v-if="!!showCreateDepartmentMail"
                class="form-group-departman"
            >
                <b-form-select
                    id="type-input"
                    v-model="selectedDepartmentId"
                    v-validate="'required'"
                    :data-vv-as="$t('message.contentType')"
                    :name="$t('message.contentType')"
                    type="text"
                >
                    <option :value="subject._id" v-for="subject in getSelectDepartmentList()">
                        {{ subject.languageContent.tr.name }}
                    </option>
                </b-form-select>
            </b-form-group>
            <div style="margin: 15px">
                <a-input
                    :aria-disabled="userEmailAddresses.length !== 0"
                    :addon-after="'@' + emailDomain"
                    v-model="emailName"
                    v-validate="'required'"
                    name="channelName"
                />
            </div>
            <div class="form-footer">
                <div class="actions">
                    <a-button @click="handleCancel">{{ $t("billing.cancel") }}</a-button>
                    <a-button
                        class="pr-confirm-btn"
                        @click="!!showCreateDepartmentMail ? createDepartment() : createUserEmail()"
                        type="primary"
                        :disabled="!domainIsCreated || !emailBtnEnabled"
                    >
                        {{ $t("settings.create") }}
                    </a-button>
                </div>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import GoogleIcon from "./icons/GoogleIcon.vue";
import MailIcon from "./icons/MailIcon.vue";
import MicrosoftIcon from "./icons/MicrosoftIcon.vue";
import { sendSocketMessage } from "../../../utils/socketStream";
import Modal2 from "../../../components/common/Modal2.vue";
import ImageMessage from "../../../components/popup-chat/messages/ImageMessage.vue";
import CONFIG from "../../../config/config";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import NewW2Channel from "../WhatsappV2/NewW2Channel.vue";
import { DEFAULT_ORGANIZATION_LOGO_URL } from "../../../utils/staticDatas";

const log = log2("MailIntegration");
export default {
    name: "MailIntegration",
    components: {
        NewW2Channel,
        WhatsappIcon,
        MailIcon,
        GoogleIcon,
        MicrosoftIcon,
        Modal2,
        ImageMessage,
        AppBreadCrumb,
    },
    props: {
        visible: {},
    },
    data() {
        return {
            logoUrl: DEFAULT_ORGANIZATION_LOGO_URL,
            connectedEmailName: false,
            isGmailIntegration: false,
            emailBtnEnabled: true,
            emailName: "",
            departmentMailAddress: [],
            userEmailAddresses: [],
            stepNumber: 1,
            showCreateUserMail: false,
            showCreateDepartmentMail: false,
            selectedDepartmentId: null,
        };
    },
    computed: {
        ...mapState({
            subjects: (state) => state.subject.subjects,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            domainIsCreated: (state) => state.mail.domainIsCreated,
            isNewDomain: (state) => state.mail.isNewDomain,
            isNewDepartment: (state) => state.mail.isNewDepartment,
            verificationToken: (state) => state.mail.verificationToken,
            allMailAddresses: (state) => state.mail.allMailAddresses,
            isNewUserMail: (state) => state.mail.isNewUserMail,
            emailDomain: (state) =>
                state.site.site.alias === "supsis"
                    ? CONFIG.EMAIL_DOMAIN
                    : `${state.site.site.alias}.${CONFIG.EMAIL_DOMAIN}`,
        }),
        ...mapGetters({}),
    },
    methods: {
        getSelectDepartmentList() {
            const createdDepartmentIds = this.departmentMailAddress.map((x) => x.department._id);
            return this.subjects.data.filter((x) => !createdDepartmentIds.includes(x._id));
        },
        getDepartmentName(value) {
            if (!!value.department && value.department._id) {
                const result = this.subjects.data.find((x) => x._id === value.department._id);
                if (!result) return "";
                return result.languageContent.tr.name;
            }
        },
        isAllowCreateDepartment() {
            return this.allMailAddresses.filter((x) => x.type === "department").length !== this.subjects.total;
        },
        showModel(isDepartment = false) {
            if (!!isDepartment && this.isAllowCreateDepartment()) {
                this.showCreateDepartmentMail = true;
            } else if (!isDepartment) {
                this.showCreateUserMail = true;
            }
        },
        mailDetail(isDepartment = false, selectedId = null) {
            if (!!isDepartment && !!selectedId.department && selectedId.department._id) {
                this.$router.push(`/integrations/mail/${selectedId.department._id}/department/detail`);
            } else {
                this.$router.push(`/integrations/mail/${selectedId}/user/detail`);
            }
        },
        handleCancel() {
            this.showCreateUserMail = false;
            this.showCreateDepartmentMail = false;
            this.emailBtnEnabled = true;
            this.$message.destroy();
        },
        getUserEmailAddress() {
            console.log("this.allMailAddresses", this.allMailAddresses);
            const result = this.allMailAddresses.filter(
                (email) =>
                    email.type === "user" &&
                    !!email.user &&
                    email.user._id === this.user._id &&
                    !!email.isVerified &&
                    !email.isForward
            );
            if (result.length === 0) return [];
            return result;
        },
        getDepartmentEmailAddress() {
            const result = this.allMailAddresses.filter((email) => email.type === "department" && !!email.isVerified);
            if (!result) return [];
            return result;
        },
        createDomain() {
            this.$message.loading("Domain oluşturuluyor..", 0);
            this.emailBtnEnabled = false;
            sendSocketMessage("email create_domain", {
                siteId: this.site._id,
                emailDomain: this.emailDomain,
            });
        },
        createDepartment() {
            if (this.emailName === "") {
                this.$message.error("Mail adı boş geçilemez!"); //todo translate
                return;
            }
            for (let i = 0; i < this.emailName.length; i++) {
                if (
                    ["ç", "ğ", "ı", "ö", "ş", "ü", "Ç", "Ğ", "İ", "Ö", "Ş", "Ü", " ", ","].includes(
                        this.emailName.charAt(i)
                    )
                ) {
                    this.$message.error("Mail özel karakter içeremez!"); //todo translate
                    return;
                }
            }
            this.$message.loading("Email oluşturuluyor..", 0); //todo translate
            this.emailBtnEnabled = false;
            sendSocketMessage("email create_department_email", {
                siteId: this.site._id,
                identity: this.emailName + "@" + this.emailDomain,
                departmentId: this.selectedDepartmentId,
                emailDomain: this.emailDomain,
            });
        },

        createUserEmail() {
            if (this.emailName === "") {
                this.$message.error("Mail adı boş geçilemez!");
                return;
            }
            for (let i = 0; i < this.emailName.length; i++) {
                if (
                    ["ç", "ğ", "ı", "ö", "ş", "ü", "Ç", "Ğ", "İ", "Ö", "Ş", "Ü", " ", ","].includes(
                        this.emailName.charAt(i)
                    )
                ) {
                    this.$message.error("Mail özel karakter içeremez!"); //todo translate
                    return;
                }
            }
            this.$message.loading("Email oluşturuluyor..", 0);
            this.emailBtnEnabled = false;
            sendSocketMessage("email create_user_email", {
                idDefault: this.userEmailAddresses <= 0,
                siteId: this.site._id,
                identity: this.emailName + "@" + this.emailDomain,
                userId: this.user._id,
                emailDomain: this.emailDomain,
            });
        },
    },
    async mounted() {
        this.userEmailAddresses = this.getUserEmailAddress();
        this.departmentMailAddress = this.getDepartmentEmailAddress();

        window.addEventListener("keydown", (e) => {
            if ("Escape" === e.key || "Esc" === e.key) {
                this.showCreateUserMail = false;
                this.showCreateDepartmentMail = false;
                this.emailBtnEnabled = true;
                this.emailName = "";
            }
        });
    },

    watch: {
        allMailAddresses(val) {
            this.userEmailAddresses = this.getUserEmailAddress();
            this.departmentMailAddress = this.getDepartmentEmailAddress();
        },
        isNewDomain(val) {
            if (!!this.domainIsCreated) {
                this.$message.destroy();
                this.$message.success("Domain oluşturuldu.");
                this.emailBtnEnabled = true;
            } else {
                this.$message.destroy();
                this.$message.error("Bir hata oluştu.");
                this.emailBtnEnabled = true;
            }
        },
        isNewUserMail(val) {
            const mailAddress = this.allMailAddresses[this.allMailAddresses.length - 1];
            if (!!mailAddress.user && mailAddress.user._id === this.user._id) {
                if (!!mailAddress.isVerified) {
                    this.$message.destroy();
                    this.$message.success("User email oluşturuldu.");
                    this.userEmailAddresses = this.getUserEmailAddress();
                    this.showCreateUserMail = false;
                    this.emailName = "";
                    this.emailBtnEnabled = true;
                } else {
                    this.$message.destroy();
                    this.$message.error("Bir hata oluştu.");
                    this.showCreateUserMail = false;
                    this.emailName = "";
                    this.emailBtnEnabled = true;
                }
            }
        },
        isNewDepartment(val) {
            const mailAddress = this.allMailAddresses[this.allMailAddresses.length - 1];
            if (!!mailAddress.isVerified) {
                this.$message.destroy();
                this.$message.success("Department email oluşturuldu.");
                this.departmentMailAddress = this.getDepartmentEmailAddress();
                this.showCreateDepartmentMail = false;
                this.emailName = "";
                this.emailBtnEnabled = true;
            } else {
                this.$message.destroy();
                this.$message.error("Bir hata oluştu.");
                this.showCreateDepartmentMail = false;
                this.emailName = "";
                this.emailBtnEnabled = true;
            }
        },
    },
};
</script>

<style lang="scss">
.form-footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    margin-top: 20px;
    background: var(--color-bg-default);
    border-top: 1px solid var(--color-border-default);
}

.form-group-departman {
    margin-bottom: 1rem;
    width: 70%;
    margin-left: 15px;
    margin-top: 15px;
}

#mail-integration {
    background: white;
    height: 100%;
    padding: 30px;

    .ant-modal-content {
        height: 700px;
        width: 1000px;
        right: 200px;
        top: -40px;
    }

    .ant-modal-body {
        height: 590px;
    }

    .channels {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 190px;
            height: 180px;
            min-width: 180px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .channel-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 190px;
            height: 180px;
            min-width: 180px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;
            padding-top: 40px;

            .web-hook-title {
                word-break: break-all;
            }

            &.disabled {
                opacity: 0.5;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                margin: 0 auto;
                width: 70px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                padding: 10px;
            }

            .name-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                font-size: 20px;
                font-weight: bold;

                .mail-name {
                    font-size: 13px !important;
                    font-weight: 400 !important;
                }
            }

            span {
                font-weight: bold;
                display: block;
                font-size: 16px;
                transition: 10ms;
            }

            .options {
                position: absolute;
                top: 5px;
                right: 5px;

                .icon-container {
                    background-color: transparent;
                    width: 25px;
                    height: 35px;
                    margin: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 3px;

                    i {
                        width: 100%;
                        height: 100%;
                        transition: 1s;
                    }
                }
            }
        }

        .channel-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #006cff;
            border-color: #006cff;
            color: #fff;

            i {
                margin: 0;
            }
        }

        .channel-add-disable {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #acc7eb;
            border-color: #acc7eb;
            color: #fff;
            cursor: auto !important;
        }
    }

    .department-integrations {
        .department-title-name {
            display: flex;
            width: 100%;
            font-size: 18px;
            font-weight: 700;
            color: #121317;
            margin-bottom: 20px;
            margin-top: 30px;
        }

        .department-name {
            font-size: initial;
            font-weight: 500;
        }
    }

    .title {
        font-size: 24px;
        font-weight: 700;
        color: #121317;
        margin-bottom: 20px;
    }

    .line {
        width: 50%;
        float: left;
    }

    .user-email-name {
        display: flex;
        width: 100%;
        font-size: 18px;
        font-weight: 700;
        color: #121317;
        margin-bottom: 10px;
        margin-top: 30px;
    }

    .user-email {
        width: 50%;
        height: 80px;
        border: 1px solid #c7d0d7;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .email-name-input {
            border: none;
            padding: 0;

            &:focus {
                border: none;
                box-shadow: none;
            }
        }
    }

    .department-email {
        width: 50%;
        height: 80px;
        border: 1px solid #c7d0d7;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .email-name-input {
            border: none;
            padding: 0;

            &:focus {
                border: none;
                box-shadow: none;
            }
        }
    }

    .fix-align {
        display: flex;
        align-items: center;

        .done {
            color: #1999e3;
            margin-right: 5px;
            font-size: 20px;
        }

        .connected-name {
            color: #1999e3;
        }

        .connect-button {
            border: 1px solid black;
            padding: 5px 10px 5px 10px;
            background: white;
            border-radius: 5px;

            &.disabled {
                border-color: rgba(0, 0, 0, 0.26);
                cursor: default;
            }

            .connect-name {
                color: black;

                &.disabled {
                    color: rgba(0, 0, 0, 0.26);
                }
            }
        }
    }

    .integrations {
        width: 50%;
        height: 80px;
        border: 1px solid #c7d0d7;
        margin-top: 10px;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .integration-name {
            color: #121317;
            font-size: 15px;
            font-weight: 500;
            display: flex;
            flex-direction: column;
        }

        .domain-name {
        }

        .img {
            width: 40px;
            height: 40px;
            margin-right: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .upload-image {
            display: flex;
            width: 40px;
            height: 40px;
        }
    }
}

.mail-integration-bread-crumb {
    padding: 5px 0 !important;
    margin-top: -25px !important;
    margin-bottom: 20px !important;
}
</style>
